export const Data = {
  items: [
    {
      id: 0,
      title: `CBA AIChat`,
      description: `Curious on solving an assignment? CBA AIChat is here to assist you with the best results.`,
      imgLink: `/assets/images/cba-chart-icon.svg`,
      to: "/dashboard/chat-gpt",
    },
    {
      id: 1,
      title: `Conversion`,
      description: `Use the conversion table and convert measurements to more familiar ones of your your choice.`,
      imgLink: `/assets/images/conversion-icon.svg`,
      to: "/dashboard/conversion",
    },
    {
      id: 2,
      title: `Dictionary`,
      description: `Troubled with a vocabulary from a book? Don’t worry
      Search for the word and the meaning will be displayed immediately.`,
      imgLink: `/assets/images/dictionary-icon.svg`,
    },
    {
      id: 3,
      title: `Library`,
      description: `Browse and download books from a neatly organized book menu in the library.`,
      imgLink: `/assets/images/library-icon.svg`,
    },
    {
      id: 4,
      title: `Notes`,
      description: `Create notes and refer to them when needed. They are permanently stored excepted deleted.`,
      imgLink: `/assets/images/notes-icon.svg`,
    },
    {
      id: 5,
      title: `Todo List`,
      description: `Add your to-do-list, assign deadlines to them. They’ll be displayed and prioritized by the deadlines.`,
      imgLink: `/assets/images/todo-icon.svg`,
      to: "/dashboard/todo",
    },
    {
      id: 6,
      title: `Youtube`,
      description: `Search your desired academic videos and watch them on You Tube.`,
      imgLink: `/assets/images/youtube-icon.svg`,
      to: "/dashboard/youtube",
    },
    {
      id: 7,
      title: `Wikipedia`,
      description: `Browse your assignments on wikipedia and get fast results.`,
      imgLink: `/assets/images/wikipedia-icon.svg`,
    },
  ],
};
